"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwappableFooterLink = void 0;
const react_1 = __importDefault(require("react"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const SwappableFooterLink = (_a) => {
    var { href, hrefTemplate, useCustomCallback, children } = _a, props = __rest(_a, ["href", "hrefTemplate", "useCustomCallback", "children"]);
    const { LinkComponent } = (0, epic_games_nav_shared_1.useLinkComponents)();
    const locale = (0, epic_games_nav_shared_1.useLocalizationLocale)();
    const { isExternal, isEmbeddedHeaderFooter, sameOrigin } = (0, epic_games_nav_shared_1.determineExternal)(href);
    const safe = !isExternal || sameOrigin;
    const target = safe ? '_self' : '_blank';
    const rel = safe ? '' : 'noopener noreferrer';
    return (react_1.default.createElement(LinkComponent, Object.assign({ path: href !== null && href !== void 0 ? href : '', locale: locale, externalHrefTemplate: hrefTemplate, isEmbedded: isEmbeddedHeaderFooter, target: target, rel: rel, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick }, props), children));
};
exports.SwappableFooterLink = SwappableFooterLink;
//# sourceMappingURL=SwappableFooterLink.js.map